import { relative } from 'iso-url';
const map = { http: 'ws', https: 'wss' };
const def = 'ws';
export default (url, location) => relative(url, location, map, def);
